<script>
import request from 'superagent'
import Cookies from 'js.cookie'

export default {
  name: 'mixin-api-client',
  methods: {
    buildRequest(request, resolve, reject, options = {}) {
      return request
          .set('X-CSRFToken', Cookies.get('csrftoken'))
          .set('X-Shop-As', options.shopAs ? options.shopAs : '')
          .end(this.end(resolve, reject))
    },
    end(resolve, reject) {
      return (error, response) => {
        if (error) {
          if (error.status == 404) {
            resolve(null)
          } else {
            reject({error: error, response: response})
          }
        } else {
          resolve(response)
        }
      }
    },
    catch(reason) {
      if (reason.error.status === 401) {
        this.$dispatch('api-error-unauthentication', reason)
      } else if (reason.error.status === 403) {
        this.$dispatch('api-error-forbidden', reason)
      }
      return Promise.reject(reason)
    },
    apiGet(path, params = {}, options = {}) {
      return new Promise((resolve, reject) => {
        this.buildRequest(
            request.get(path).query(params),
            resolve,
            reject,
            options
        )
      }).catch(this.catch)
    },
    apiPost(path, data = {}, options = {}, params = {}) {
      return new Promise((resolve, reject) => {
        this.buildRequest(
            request.post(path).query(params).send(data),
            resolve,
            reject,
            options
        )
      }).catch(this.catch)
    },
    apiPut(path, data = {}, options = {}) {
      return new Promise((resolve, reject) => {
        this.buildRequest(
            request.put(path).send(data),
            resolve,
            reject,
            options
        )
      }).catch(this.catch)
    },
    apiDelete(path, options = {}) {
      return new Promise((resolve, reject) => {
        this.buildRequest(
            request.delete(path),
            resolve,
            reject,
            options
        )
      }).catch(this.catch)
    },
  },
}
</script>



// WEBPACK FOOTER //
// api-client.vue?3762d072